import { Component, Input } from '@angular/core';
import { CdkStep } from '@angular/cdk/stepper';

@Component({
  standalone: false,
  selector: 'irembogov-step',
  templateUrl: './irembogov-step.component.html',
  providers: [{ provide: CdkStep, useExisting: IrembogovStepComponent }],
})
export class IrembogovStepComponent extends CdkStep {
  @Input() icon?: string;
  @Input() showDoneicon = true;
}
